import React, { useEffect } from 'react'
import { API } from '@/lib/api'
import { httpRequest } from '@/lib/http'

const STORAGE_KEY = 'lo_visitor_id'

function getOrCreateVisitorId() {
  try {
    let id = localStorage.getItem(STORAGE_KEY)
    if (id && id.length >= 8 && /^[a-zA-Z0-9_-]+$/.test(id)) return id
    const next =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `v${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 14)}`
    localStorage.setItem(STORAGE_KEY, next)
    return next
  } catch {
    return null
  }
}

/**
 * Envoie au plus une ligne visite / jour / navigateur (clé locale) pour les KPI.
 * Échecs silencieux (pas d’impact UX).
 */
export default function SiteVisitBeacon() {
  useEffect(() => {
    const visitorId = getOrCreateVisitorId()
    if (!visitorId || visitorId.length < 8) return
    const path = typeof window !== 'undefined' ? window.location.pathname.slice(0, 500) : '/'
    httpRequest(`${API}/telemetry/site-visit`, {
      method: 'POST',
      body: { visitor_id: visitorId, path },
    }).catch(() => {})
  }, [])
  return null
}
